import { currentDomain, getFacebookClientId } from "../../../utils/general-config";
import FacebookLogin from "react-facebook-login";
import { useTranslation } from "react-i18next";
import InputText from "../../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import AppleSignin from "react-apple-signin-auth";
import { getPdfSimpliBaseURL, getWorksimpliEndPoint } from "../../../services/api-constants";
import { useLocation, useParams } from "react-router-dom";
import Footer from "../../../components/footer/component";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DomainName } from "../../../utils/constants";
import { appleClientId, getAppleredirectUri } from "../../../utils/general-config";
import { getPortalCD, isOfferPlan } from "../../../utils/helpers";
import { useEffect, useState, useRef } from "react";
import GoogleCaptcha from "../../sign-up/captcha";
import PSRLeftSideImg from "./pSRLeftSideSI";
import SecureSimpliLeftSideSection from "../../sign-up/secureSimpli/secureSimpliLeftSideSection";

const PSRSignIn = ({
  pwdNavigate,
  signUpNavigate,
  onSignIn,
  disableBtn,
  responseFacebook,
  googleLogin,
  passwordError,
  emailError,
  passwordErrorMsg,
  onEmailChangeHandler,
  emailId,
  onPwdChangeHandler,
  onPasswordKeyPress,
  pwd,
  appleLogin,
  isOfferPlanValid,
  privacyPolicy,
  termsOfUse,
  showCaptcha,
  onCaptchaSuccess,
  recaptchaRef,
  loginError,
  loginErrorMessage,
}) => {
  const { t } = useTranslation();
  const { locale } = useParams();
  const portalCD = getPortalCD(locale);
  let redirctUri = getAppleredirectUri();
  let Domain = currentDomain().toLowerCase();
  let checkOfferPlan = false;
  const fbIconRef = useRef(null);

  try {
    if (typeof isOfferPlan === "function") {
      checkOfferPlan = !!isOfferPlan();
    }
  } catch (e) {
    checkOfferPlan = false;
  }
  const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
  useEffect(() => {
    const isPdfSimpliExtension = queryParams.get("ispdfsimpliextension") === "true";
    const isGoogleLogin = queryParams.get("isgooglelogin") === "true";
    const isFacebookLogin = queryParams.get("isfacebooklogin") === "true";
    const isAppleLogin = queryParams.get("isapplelogin") === "true";

    if (!isPdfSimpliExtension) return;

    const timers = [];

    // Google login
    if (isGoogleLogin) {
      const timer = setTimeout(() => {
        const googleBtn = document.getElementById("googleBtn");
        googleBtn?.click();
      }, 500);
      timers.push(timer);
    }

    // Facebook login
    if (isFacebookLogin) {
      const timer = setTimeout(() => {
        const fbBtn = document.getElementById("fbBtn");
        fbBtn?.click();
      }, 500);
      timers.push(timer);
    }

    // Apple login
    if (isAppleLogin) {
      const timer = setTimeout(() => {
        const appleBtn = document.querySelector(".apple-signin-button");
        appleBtn?.click();
      }, 500);
      timers.push(timer);
    }
    return () => timers.forEach(clearTimeout);
  }, [location.search]);

useEffect(() => {
  if (!fbIconRef.current) return;
  const isPdfSimpliExtension = queryParams.get("ispdfsimpliextension") === "true";
  if (isPdfSimpliExtension) {
    const forceLogin = () => {
      if (window.FB) {
        window.FB.login((response) => responseFacebook(response), {
          scope: "public_profile,email",
          auth_type: "rerequest",
        });
      }
    };
    fbIconRef.current.addEventListener("click", forceLogin);

    return () => {
      fbIconRef.current?.removeEventListener("click", forceLogin);
    };
  }
}, []);

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content={
            Domain === DomainName.PDFSIMPLI ? t("sign_in.ps.description_meta") : t("sign_in.ws.description_meta")
          }
        />
        <title>{Domain === DomainName.PDFSIMPLI ? t("page_title.ps.sign_in") : t("sign_in.ws.meta_title")}</title>
      </Helmet>
      <section className="main-content !min-h-[calc(100vh-9.7rem)] min-[1250px]:!pt-3 min-[1400px]:!pt-12 backdrop-blur-[100px] bg-blur-bg-rs !font-rethink">
        <div className="flex justify-center items-center flex-col">
          <div className="container min-[1000px]:!pb-[1.5rem] min-[1400px]:!pb-0 mx-auto">
            <div className="flex w-full justify-center items-center flex-col md:flex-row gap-x-12">
              {portalCD === "PSSC" ? (
                <SecureSimpliLeftSideSection />
              ) : (
                <div className="!hidden md:flex w-full md:w-2/5 order-2 md:order-1 lg:max-w-[400px] lg:h-[450px] justify-center items-center">
                  <PSRLeftSideImg />
                </div>
              )}

              <div className="w-full lg:w-2/5 md:w-3/5 min-[1400px]:w-[48.5%] order-1 md:order-2">
                <div className="form-wrap-psr relative p-[2px] rounded-xl bg-rs-border-gradient w-full">
                  <div className="rounded-xl py-8 px-4 bg-white shadow-sm md:shadow-md  min-[1400px]:py-[40px] min-[1400px]:px-[60px]">
                    <hgroup className="text-center user-page">
                      <h1 className="main-headline text-[#16283D] text-2xl md:text-4xl font-bold mt-0 pb-2.5 !leading-10">
                        {t("sign_in.ps.headline")}
                      </h1>
                      {checkOfferPlan && (
                        <h3 className="text-[#16283D] text-lg font-normal mb-4 pb-2 px-4 md:px-8">
                          Unlock your exclusive VIP offer by signing up for your account now
                        </h3>
                      )}
                    </hgroup>

                    <div className="social-login  justify-between flex-col w-full">
                      <div className="flex items-center">
                        <div className="social-login--google w-full mb-0">
                          <button
                            type="button"
                            className="google-login-button text-xs lg:text-sm text-white !bg-[#4181EF] mt-[1px] w-auto !flex items-center justify-center h-[41px] rounded-[5px]"
                            onClick={googleLogin}
                            id="googleBtn"
                          >
                            <div className="bg-white ml-[2px] rounded-l-md rtl:hidden">
                              <img
                                src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"}
                                height="20px"
                                width="20px"
                                alt="Google"
                              />
                            </div>
                            <span className="text-sm lg:text-base rtl:ml-0 ml-10 !font-rethink">
                              {t("sign_in.signin_with_google")}
                            </span>{" "}
                            <div className="bg-white ml-[2px] rounded-r-md !right-0 !left-auto mr-[1px] ltr:hidden">
                              <img
                                src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"}
                                height="20px"
                                width="20px"
                                alt="Google"
                              />
                            </div>
                          </button>
                        </div>
                        <div className="social-login--facebook !leading-none mb-0 rtl:mr-1 ">
                          <FacebookLogin
                            appId={getFacebookClientId()}
                            autoLoad={false}
                            fields="name,email"
                            textButton=""
                            callback={responseFacebook}
                            cssClass=""
                            size="!w-[41px] !h-[40px] "
                            icon={
                              <img
                                ref={fbIconRef}
                                src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                                className="facebook-login-button border border-[#EAEBED] !w-[41px] !h-[40px]  !relative !rounded-[5px]"
                                id="fbBtn"
                                alt="Facebook"
                              />
                            }
                          />
                        </div>
                      </div>

                      <div className="social-login--apple w-full">
                        <AppleSignin
                          className="apple-signin-button"
                          authOptions={{
                            clientId: appleClientId(),
                            scope: "email name",
                            redirectURI: redirctUri + "signin-apple",
                            usePopup: true,
                          }}
                          onSuccess={appleLogin}
                          onError={(error) => {
                            console.error("Apple login failed:", error);
                            appleLogin({
                              user: null,
                              authorization: {
                                id_token: null,
                                error: error.message,
                              },
                            });
                          }}
                          uiType="light"
                          buttonExtraChildren={null}
                          style={{ display: "none" }}
                        />
                        <button
                          onClick={() => document.querySelector(".apple-signin-button").click()}
                          className="relative flex items-center justify-center px-2.5 py-2 border border-[#EAEBED] bg-white cursor-pointer rounded-md w-full -mt-[6px]"
                        >
                          <img
                            src={process.env.PUBLIC_URL + "/static/images/apple-icon.svg"}
                            alt="Apple"
                            className="absolute left-3 w-5 h-6"
                          />
                          <span className="text-center w-full ml-5">{t("sign_in.signin_with_apple")}</span>
                        </button>
                      </div>
                    </div>
                    <div className="or-container !mt-3 !-mb-2 !font-rethink !text-[#687585] !text-md">
                      <span></span> {t("sign_in.or")} <span></span>
                    </div>
                    <div className="form-text mb-10 mt-2">
                      {(passwordError || emailError) && (
                        <p
                          key="pswrdErr"
                          className="text-red-600 text-center w-full "
                          dangerouslySetInnerHTML={{
                            __html: passwordErrorMsg,
                          }}
                        />
                      )}
                      {loginError && <p className="text-center text-red-500">{loginErrorMessage}</p>}
                    </div>
                    <div className="mx-auto my-2 !max-w-96">
                      <div className="">
                        <InputText
                          showLabel={false}
                          id="email"
                          text="Email Address"
                          onChange={onEmailChangeHandler}
                          className="border-gray-300 rounded  p-2 border mb-3 !font-rethink"
                          value={emailId.trim()}
                          maxLength={100}
                          placeholder={t("sign_in.ps.placeholder_email")}
                        />
                      </div>
                      <div className="">
                        <InputText
                          showLabel={false}
                          id="password"
                          text="Password"
                          type="password"
                          onChange={onPwdChangeHandler}
                          value={pwd}
                          className="border-gray-300 rounded  p-2 border mb-3 !font-rethink"
                          onKeyPress={onPasswordKeyPress}
                          placeholder={t("sign_in.ps.placeholder_password")}
                        />
                      </div>
                      <div className="flex flex-col items-center space-y-3">
                        <div className="check_box flex justify-between items-center w-full px-1 !mt-[6px]">
                          <label className="form-check flex items-center space-x-2 text-sm text-[#424a5c]">
                            <input id="checkbox-btn" className="form-check-input" type="checkbox" value="" />
                            <span className="checkmark peer-checked:bg-orange-500">
                              <span className="rtl: mr-2 font-normal text-sm">{t("sign_in.ps.remember_me")}</span>
                            </span>
                          </label>
                          <button
                            id="ForgotPassword"
                            className="setCulture text-sm text-[#0f67cb] font-normal decoration-[#0f67cb] underline !font-rethink"
                            isLoading={false}
                            disabled={disableBtn}
                            onClick={pwdNavigate}
                          >
                            {t("sign_in.ps.forgot")}
                          </button>
                        </div>
                        {showCaptcha && (
                          <div className="flex flex-row justify-center mt-2" style={{ width: "304px" }}>
                            <GoogleCaptcha onCaptchaSuccess={onCaptchaSuccess} recaptchaRef={recaptchaRef} />
                          </div>
                        )}
                        <div
                          className={`fbn bounce-effect md:relative bottom-0 left-0 bg-white border-gray-300 text-center w-full z-50 ${
                            showCaptcha ? "" : "p-0 md:py-[20px]"
                          }`}
                        >
                          <button
                            id="log-in"
                            className="text-white p-4 w-full leading-[120%] !font-rethink tracking-[2%] h:[60px] md:h-[62px] text-lg font-bold rounded-[100px] bg-ps-reskin-radial hover:bg-hover-ps-reskin-radial uppercase
                transition-colors duration-1000 ease-in-out"
                            isLoading={false}
                            disabled={false}
                            type="submit"
                            onClick={onSignIn}
                          >
                            {t("sign_in.btn_cta")}
                          </button>
                        </div>{" "}
                        {!isOfferPlanValid && (
                          <p className="mt-4 text-sm md:text-base">
                            {t("sign_in.ps.don't _have_account")}
                            <button
                              id="sign-up-btn"
                              className="setCulture font-normal text-[#0E76FF] hover:text-[#f9593a] mb-[10px] ml-1 text-sm !font-rethink"
                              isLoading={false}
                              disabled={disableBtn}
                              onClick={signUpNavigate}
                            >
                              <span className="mr-1 text-[#0E77FF]">
                                <FontAwesomeIcon icon={faUserCircle} className="pt-1" />
                              </span>{" "}
                              <span className="text-[#0E76FF] underline capitalize">{t("sign_in.sign_up")}</span>
                            </button>
                          </p>
                        )}
                        {checkOfferPlan && (
                         <p className="from_bottom text-[#16283D] text-sm text-center pt-1 pb-0 sm:pb-3 font-light px-4 leading-tight">
                      {t("sign_up.ps.by_continuing")}{" "}
                      <a href={termsOfUse} target="_blank" className="setCulture text-blue-600 hover:text-[#0B58C9]">
                        {t("sign_up.ps.term_of_use")}
                      </a>{" "}
                      {t("sign_up.ps.and")}{" "}
                      <a
                        href={privacyPolicy}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="setCulture text-blue-600 hover:text-[#0B58C9]"
                      >
                        {t("sign_up.ps.privacy_policy")}
                      </a>
                      .
                    </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default PSRSignIn;
